import { SectionVerticalSlide } from "@/components";
import { Footer } from "@/components/layout/footer";
import { useGetBaseInfo, useGetRoom, type BaseInfoResponse, type RoomBaseInfoResponse } from "@/shared/server";
import { Center, Spinner, Text } from "@chakra-ui/react";
import { useParams } from "react-router-dom";
import { CTASection, RoomDetail, RoomFeed } from "../common";
import { OtherRoomPreView } from "../common/components/otherRoomPreview";
import { TopSection } from "../common/components/topSection";

export const Rooms = () => {
    const { roomIdx } = useParams<string>();
    const option = { enabled: !!roomIdx };

    const { data: footerData } = useGetBaseInfo<BaseInfoResponse>();
    const { data } = useGetRoom<RoomBaseInfoResponse>({ roomIdx: roomIdx ?? "" }, option);
    return data && footerData ? (
        <SectionVerticalSlide>
            <TopSection imgList={data.imgList} catchPraise={data.catchPraise} />
            <RoomDetail roomIdx={data.roomIdx} />
            <RoomFeed roomIdx={data.roomIdx} />
            <OtherRoomPreView />
            <CTASection imgList={data.imgList} />
            <Footer
                isPrivate={footerData.isPrivate}
                logoUrl={footerData.logoUrl}
                pensionInfo={footerData.pensionInfo}
            />
        </SectionVerticalSlide>
    ) : (
        <Center w="100" h="100vh" columnGap="8px">
            <Text>LOADING</Text>
            <Spinner />
        </Center>
    );
};
